import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Radio } from "antd";
import { AlertOutlined } from "@ant-design/icons";

const MailDeliveryNotification = ({
  deliveryFailureReport,
  canModifyGroup,
  updateGroupMailProperties,
}) => {
  const handleDeliveryIssueNotificationRadioChange = (e) => {
    updateGroupMailProperties({ deliveryFailureReport: e.target.value });
  };

  return (
    <Card
      style={{ marginBottom: 14 }}
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          <AlertOutlined style={{ marginRight: 8, color: "#bfbfbf" }} />
          Who will be notified in case of mail delivery problems?
        </Typography.Title>
      }
    >
      <Radio.Group
        onChange={handleDeliveryIssueNotificationRadioChange}
        value={deliveryFailureReport}
        disabled={!canModifyGroup}
      >
        <Radio value="ReportToSender">Mail Sender (default)</Radio>
        <br />
        <Radio value="ReportToOwner">Group Owner</Radio>
        <br />
        <Radio value="NoReport">No Notification</Radio>
      </Radio.Group>
    </Card>
  );
};

MailDeliveryNotification.propTypes = {
  deliveryFailureReport: PropTypes.string,
  canModifyGroup: PropTypes.bool,
  updateGroupMailProperties: PropTypes.func,
};

export default MailDeliveryNotification;
